import React, { useEffect, useState, useMemo } from "react";
import { Button, Col, Input, message, Modal, Row, Space, Switch, Table, Tooltip, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { currentUserSelector } from "../Auth/Login/selector";
import { actions as integrationActions } from "/src/views/Integrations/redux";
import { integrationsSelector } from "../Integrations/selector";
import { actions as orgIntegrationActions } from "./redux";
import { orgIntegrationsSelector } from "./selector";
import { clone, cloneDeep, debounce } from "lodash";
import Spinner from "/src/components/UI/Spinner/Spinner";
import {
  SettingOutlined,
} from "@ant-design/icons";
import { SelectProgram } from "/src/components/AppSpecific/SelectSubject/SelectSubject";
import { useTranslate } from "/src/lib/MrTranslate/MrTranslate";
import { orgProgrammesSelector } from "../OrgProgrammes/selector";
import "./OrgIntegration.scss";
import { InfoCircleOutlined } from "@ant-design/icons";
import { showConfirmModal } from "/src/components/UI/Segment/UIHelper";
import { enabledFeaturesSelector } from "/src/views/Auth/Login/selector";
import { axiosInstance } from "/src/api/apiModule";
import { isStringEmptyOrHasBlankSpace } from "/src/lib/utils/helperMethods";

const RenderSwitch = ({ record, disabled, handleSwitchChange }) => {
  const defaultEnabled = record.enabled || false;
  const [checked, setChecked] = useState(defaultEnabled);
  const mrIntl = useTranslate();
  return (
    <Switch
      checked={checked}
      title={disabled && mrIntl("OrgIntegration.select_settings")}
      disabled={disabled}
      onChange={(checked) => {
        handleSwitchChange(record, checked, true);
        setChecked(checked);
      }}
    />
  );
};

const SyncConfigTable = ({ syncConfig, setSyncConfig }) => {
  console.log("syncConfig =====>", syncConfig);
  const handleSyncChange = (entity, checked) => {
    setSyncConfig(prev => ({
      ...prev,
      [entity]: {
        ...prev[entity],
        sync: checked
      }
    }));
  };

  const handleUpdateChange = (entity, checked) => {
    setSyncConfig(prev => ({
      ...prev,
      [entity]: {
        ...prev[entity],
        should_update: checked
      }
    }));
  };

  const handleStrictProgramCheckChange = (entity, checked) => {
    setSyncConfig(prev => ({
      ...prev,
      [entity]: {
        ...prev[entity],
        strict_program_check: checked
      }
    }));
  };

  const dataSource = Object.entries(syncConfig).map(([key, value]) => ({
    key,
    entity: key,
    sync: value.sync,
    should_update: value.should_update,
    strict_program_check: value.strict_program_check
  }));

  const syncColumns = [
    {
      title: 'Entity',
      dataIndex: 'entity',
      key: 'entity',
      width: 150,
      render: (text) => text.charAt(0).toUpperCase() + text.slice(1)
    },
    {
      title: 'Sync',
      dataIndex: 'sync',
      key: 'sync',
      width: 100,
      render: (value, record) => {
        console.log("record =====>", record.sync);
        return (
          <Switch
            checked={record.sync}
            onChange={(checked) => handleSyncChange(record.entity, checked)}
          />
        )
      }
    },
    {
      title: 'Should Update',
      dataIndex: 'should_update',
      key: 'should_update',
      width: 120,
      render: (value, record) => (
        <Switch
          checked={value}
          onChange={(checked) => handleUpdateChange(record.entity, checked)}
        />
      )
    }
  ];

  return (
    <div>
      <Table
        columns={syncColumns}
        dataSource={dataSource}
        pagination={false}
        size="small"
        bordered
      />
    </div>
  );
};



const defaultSyncConfig = {
  orgs: {
    sync: false,
    should_update: false,
  },
  grades: {
    sync: false,
    should_update: false,
  },
  sessions: {
    sync: false,
    should_update: false,
  },
  departments: {
    sync: false,
    should_update: false,
  },
  subjects: {
    sync: false,
    should_update: false,
  },
  courses: {
    should_update: false,
    sync: false
  },
  classes: {
    sync: false,
    should_update: false,
  },
  enrollments: {
    sync: false,
    should_update: false,
  },
  users: {
    sync: false,
    should_update: false,
    strict_program_check: false
  }
}

const defaultEdlinkMappings = {
  map_all_schools_in_district: false,
  create_sessions_in_district: false,
  create_departments_in_district: false,
  create_subjects_in_district: false,
  create_courses_in_district: false,
  create_grades_in_district: false,
  create_district_sessions_in_all_schools: false,
  create_district_departments_in_all_schools: false,
  create_district_subjects_in_all_schools: false,
  create_district_courses_in_all_schools: false,
  sync_school_as_session: false,
  sync_subject_as_department: false,
  sync_course_as_subject: false,
  use_additional_school_identifier: false
}

const OrgIntegration = ({ orgId , org }) => {
  const dispatch = useDispatch();
  const currentUser = useSelector(currentUserSelector());
  const integrations = useSelector(integrationsSelector());
  const orgIntegrations = useSelector(orgIntegrationsSelector());
  const enabledFeatures = useSelector(enabledFeaturesSelector());
  const mrIntl = useTranslate();

  const isSuperadmin = currentUser.role === "superadmin";
  const isAdmin = currentUser.role === "admin";

  const [showModal, setShowModal] = useState(false);
  const [showLogsModal, setShowLogsModal] = useState(false);
  const [showSyncModal, setShowSyncModal] = useState(false);
  const [syncParams, setSyncParams] = useState({
    full_sync: false,
    force_start: false
  });
  const [enabledIntegrations, setEnabledIntegrations] = useState([]);
  const [activeIntegrationId, setActiveIntegrationId] = useState(null);
  const [integrationLabel, setIntegrationLabel] = useState(null);
  const [orgIntegrationSetting, setOrgIntegrationSetting] = useState({});
  const [selectedIntegrationLogs, setSelectedIntegrationLogs] = useState(null);
  console.log("orgIntegrationSetting =====>", orgIntegrationSetting.edlink_settings);
  const [syncConfig, setSyncConfig] = useState(orgIntegrationSetting?.edlink_settings || defaultSyncConfig);
  const [edlinkMappings, setEdlinkMappings] = useState(orgIntegrationSetting?.edlink_mappings || defaultEdlinkMappings);
  const showConfirmModalContent = orgIntegrationSetting.org_programme_id ?
    mrIntl("OrgIntegration.are_you_sure_you_want_to_modify_the_integration_id")
    : mrIntl("OrgIntegration.once_you_select_a_program_you_cannot_change_it")

  let currentIntegrationOrgProgrammeId = null;
  let currentEdlinkIntegrationId = null;
  let currentIntegrationSourceId = null;
  let shouldDisableOrgProgrammeSelector = false;
  
  if (activeIntegrationId && orgIntegrationSetting) {
    currentIntegrationOrgProgrammeId = orgIntegrationSetting?.org_programme_id;
    currentEdlinkIntegrationId = orgIntegrationSetting?.edlink_integration_id;
    currentIntegrationSourceId = orgIntegrationSetting?.org_source_id;
    shouldDisableOrgProgrammeSelector = orgIntegrationSetting?.org_programme_id ? true : false;
  }

  const [disableButton, setDisableButton] = useState(true);
  const [isFieldsValidated, setIsFieldsValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  useEffect(() => {
    const debouncedEffect = debounce(() => {
      console.log("enabledIntegrations =====>", enabledIntegrations, orgIntegrations);
      
      // for superadmins, we are merging both 'orgIntegration' and 'integration', while for admins, we are displaying only 'orgIntegrations'. 
      if (isSuperadmin) {
        let updatedIntegrations = cloneDeep(integrations);
        if (orgIntegrations.length > 0 || updatedIntegrations.length > 0) {
          updatedIntegrations = integrations.filter(integration => !integration.archived).map((integration) => {
            const currentOrgIntegration = orgIntegrations.find(item => item.integration_id === integration.id);
            console.log("orgIntegration ========>", currentOrgIntegration);
            if (!currentOrgIntegration) {
              integration.enabled = false;
            }
            return currentOrgIntegration || integration;
          });
          if (updatedIntegrations.length > 0) {
            setEnabledIntegrations(updatedIntegrations);
          }
        }
      } else {
        if (orgIntegrations.length > 0) {
          const newOrgIntegrations = orgIntegrations.filter((oi) => oi.enabled === true && !oi.archived);          
          setEnabledIntegrations(newOrgIntegrations);
        }
      }
    }, 300); 

    debouncedEffect();

    return () => {
      debouncedEffect.cancel();
    };
  }, [orgIntegrations, integrations]);

  const isInvalid = (val) => isStringEmptyOrHasBlankSpace(val); 
  const isMissing = (val) => val === undefined || isStringEmptyOrHasBlankSpace(val);

  useEffect(() => {
    setShowErrorMessage(isInvalid(currentEdlinkIntegrationId) || isInvalid(currentIntegrationSourceId));
    setDisableButton(isMissing(currentEdlinkIntegrationId) || isMissing(currentIntegrationSourceId) || !currentIntegrationOrgProgrammeId);
  }, [currentEdlinkIntegrationId, currentIntegrationSourceId, currentIntegrationOrgProgrammeId]); 

  useEffect(() => {
    dispatch(orgIntegrationActions.fetch({ params: { by_org_id: orgId } }));
    if (isSuperadmin) {
      dispatch(integrationActions.fetch());
    }
  }, [currentUser.role, dispatch]);

  const handleSwitchChange = (record, checked, shouldNotUpdateSetting = false) => {
    const id = record.integration_id || record.id;
    const index = orgIntegrations.findIndex(item => item.integration_id === id);
    const currentSettings = orgIntegrationSetting;
    console.log("index ========>", currentSettings, record);
    if (index === -1) {
      dispatch(orgIntegrationActions.create({
        label: record.label, integration_id: id, org_id: orgId, enabled: checked,         settings: {
          edlink_integration_id: currentSettings.edlink_integration_id,
          org_source_id: currentSettings.org_source_id,
          org_programme_id: currentSettings.org_programme_id,
          edlink_settings: syncConfig,
          edlink_mappings: edlinkMappings,
          edlink_include_schools: currentSettings.edlink_include_schools || ''
        },
      }, {
        success: {
          showMessage: true,
          message: mrIntl("OrgIntegration.integration_updated_successfully"),
        },
      }));
    } else if (shouldNotUpdateSetting) {
      dispatch(orgIntegrationActions.update({ id: record.id, enabled: checked }))
    } else {
      const settings = {
        ...record.settings,
        edlink_integration_id: currentSettings.edlink_integration_id,
        org_source_id: currentSettings.org_source_id,
        edlink_settings: syncConfig,
        edlink_mappings: edlinkMappings,
        edlink_include_schools: currentSettings.edlink_include_schools || ''
      }
      if (!settings?.org_programme_id) {
        settings["org_programme_id"] = orgIntegrationSetting.org_programme_id;
      }
      dispatch(orgIntegrationActions.update({ id: record.id, enabled: checked, settings: settings }, {
        success: {
          showMessage: true,
          message: mrIntl("OrgIntegration.integration_updated_successfully"),
        },
      }));
    }
  };

  const handleSyncClick = (record) => {

    if (record.code === "oneroster") {
      handleOneRosterSync(record?.id, record?.code);
    } else {
      setActiveIntegrationId(record.integration_id || record.id);
      setShowSyncModal(true);
    }
  }

  const handleSync = () => {
    message.success(mrIntl("OrgIntegration.sync_started_successfully"))
    dispatch(integrationActions.edlinkSync({
      org_id: orgId,
      integration_id: activeIntegrationId,
      full_sync: syncParams.full_sync,
      force_start: syncParams.force_start
    }));
    setShowSyncModal(false)
  }

  const handleSyncEvent = () => {
  axiosInstance.instance.post('/orgs/sync_cron')
    .then(response => {
      message.success(response.data.message);
    })
    .catch(error => {
      message.error("Something went wrong! please try again.");
      console.error("Sync Cron Error:", error);
    });
  }

  const handleOneRosterSync = (orgIntegrationId, code) => {
    const url = `/orgs/${orgId}/sync_org_integrations`;
    const params = {
      id: orgId,
      org_integration_id: orgIntegrationId,
      sync_type: code,
    };

    axiosInstance.instance
      .post(url, { ...params })
      .then((response) => {
        message.success(response.data.message);
      })
      .catch((error) => {
        message.error("OneRoster sync failed. Please try again.");
        console.error("OneRoster Sync Error:", error);
      });
  };

  // const renderAdminControls = () => (
  //   <>
  //     {org.is_edlink ? (
  //       mrIntl("OrgIntegration.your_integration_is_paused_due_to_technical_reasons")
  //     ) : (
  //       mrIntl("OrgIntegration.the_integration_is_not_set_up_yet")
  //     )}
  //   </>
  // );

  const columns = [
    {
      title: "Integration name",
      dataIndex: "label",
      key: "label",
      width: 150,
    },
  ];

  if (isSuperadmin) {
    columns.push({
      title: "Enabled",
      key: "enabled",
      width: 100,
      render: (record) => {
        const ogs = orgIntegrationSetting
       const shouldDisable =
         (record.code === "oneroster" && !record.enabled) ||
         (record.settings?.edlink_integration_id &&
           record.settings?.org_source_id)
           ? false
           : true;
       console.log("ogs =====>", ogs, shouldDisable);
       return (
         <RenderSwitch
           disabled={shouldDisable}
           record={record}
           handleSwitchChange={handleSwitchChange}
         />
       );
      },
    });
    columns.push(
      {
        title: "Settings",
        key: "settings",
        width: 100,
        render: (record) => {
          const settings = record.settings;
          return (<Button onClick={() => {
            const integrationId = record.integration_id || record.id // We are doing this because in record we have integration or orgIntegration 
            setIsFieldsValidated(false)
            setShowModal(!showModal)
            setIntegrationLabel(record.label)
            setActiveIntegrationId(integrationId);
            if (settings) {
              setOrgIntegrationSetting(settings)
              setSyncConfig(settings.edlink_settings || defaultSyncConfig)
              setEdlinkMappings(settings.edlink_mappings || defaultEdlinkMappings)
            }
          }}  type="text" 
          disabled={record.code === "oneroster"}
          icon={<SettingOutlined />}></Button>)
        },
      }
    )
  }

  if (isAdmin || isSuperadmin) {
    columns.push(
      {
        title: "Sync",
        key: "sync",
        width: 300,
        render: (record) => {
          const ogs = orgIntegrationSetting;
          // Start of Selection
          return (
            <Space>
              <Button
                title={
                  !ogs?.org_programme_id &&
                  mrIntl("OrgIntegration.select_settings")
                }
                disabled={!record.enabled}
                onClick={() => handleSyncClick(record)}
              >
                Sync
              </Button>
            </Space>
          );
        },
      }
    );
  }
  if (isSuperadmin) {
    columns.push(
      {
        title: "Logs",
        key: "logs",
        width: 100,
        render: (record) => <Tooltip title="Show Logs">
          <Button onClick={() => {
            if (record?.custom_fields?.edlink_logs) {
              setSelectedIntegrationLogs(record?.custom_fields?.edlink_logs)
            }
            setShowLogsModal(!showLogsModal)
            setIntegrationLabel(record.label)
            console.log("record =====>", record);
          }} type="text" icon={<InfoCircleOutlined />}>
          </Button>
        </Tooltip>,
      }
    );
  }

  const updateSetting = (keyToUpdate, value) => {
    setOrgIntegrationSetting({
      ...orgIntegrationSetting,
      [keyToUpdate]: value
    })
  }

  const showSettingsModal = () => {
    setShowModal(!showModal)
    const activeIntegration = enabledIntegrations.find(item => (item.integration_id || item.id) === activeIntegrationId);
    const checked = activeIntegration.enabled;
    handleSwitchChange(activeIntegration, checked);
  }

  const handleValidation = (integration_id, source_id) => {
    const activeIntegration = enabledIntegrations.find(item => (item.integration_id || item.id) === activeIntegrationId);
    dispatch(orgIntegrationActions.validate(
      {
        org_id: orgId,
        integration_id: integration_id,
        source_id: source_id,
        source_provider: activeIntegration.label,
      },
      {
        successCallback: (data) => {
          console.log("checksuccess", data)
          setIsFieldsValidated(!isFieldsValidated)
          setLoading(false)
        },
        errorCallback: () => {
          setLoading(false)
        }
      } 
    ))
  }
  
  if (integrations.length > 0 && enabledIntegrations.length === 0) {
    return <Spinner />
  }
  console.log("enabledIntegrations =====>", orgIntegrationSetting);
  
  return (
    <>
      {enabledIntegrations.length === 0 && isAdmin && mrIntl("OrgIntegration.the_integration_is_not_set_up_yet")}
      {enabledIntegrations.length > 0 && (
        <Table
          className="integrations-table"
          columns={columns}
          dataSource={enabledIntegrations}
          rowKey="id"
          pagination={false}
        />
      )}
      <Modal title={`${integrationLabel} integration settings`} closable={false} visible={showModal}
        onCancel={() => {
          setShowModal(!showModal)
          setActiveIntegrationId(null)
        }}
        okText={loading ? "Validating" : isFieldsValidated ? "Save" : "Validate"}
        onOk={() => {
          if (!isFieldsValidated) {
            handleValidation(currentEdlinkIntegrationId, currentIntegrationSourceId);
            setLoading(true);
          } else {
            showConfirmModal({
              centered: true,
              content: showConfirmModalContent,
              onOk: () => {
                showSettingsModal();
              },
            });
          }
        }}
        okButtonProps={{
          loading: loading,
          disabled: loading || disableButton,
        }}
      >
        {isSuperadmin && (
          <>
            <Row>
              <Col span={22}>
                {mrIntl("OrgIntegration.integration_id")}
                <Input
                  placeholder={mrIntl("OrgIntegration.integration_id")}
                  value={currentEdlinkIntegrationId}
                  onChange={(event) => updateSetting("edlink_integration_id", event.target.value)}
                />
              </Col>
              <Col span={22}>
                {org.org_type === "district" ? "District id" : mrIntl("OrgIntegration.school_id")}
                <Input
                  placeholder={org.org_type === "district" ? "District id" : mrIntl("OrgIntegration.school_id")}
                  value={currentIntegrationSourceId}
                  onChange={(event) => updateSetting("org_source_id", event.target.value)}
                />
              </Col>
            </Row>
            <Col span={22}>{mrIntl("OrgIntegration.select_program")}
              <SelectProgram
                key="selectOrgProgrammeFilter"
                dropdownMatchSelectWidth={false}
                value={currentIntegrationOrgProgrammeId}
                disabled={shouldDisableOrgProgrammeSelector}
                onChange={(value) => updateSetting("org_programme_id", value)}
                config={{
                  params: { by_org_id: orgId },
                  widgetConfig: {
                    style: { width: "100%" },
                    placeholder: mrIntl("ExperiencesFilter.all_programs"),
                  }
                }}
              />
            </Col>
            Include Schools
            <Input
              placeholder={mrIntl("OrgIntegration.include_schools")}
              value={orgIntegrationSetting?.edlink_include_schools || ''}
              onChange={(event) => updateSetting("edlink_include_schools", event.target.value)}
            />
            <span className={`c-red ${showErrorMessage ? "visibility-visible" : "visibility-hidden"}`}>
              {mrIntl("OrgIntegration.integration_or_source_id_cannot_be_empty_or_contain_spaces")}
            </span>
            <div>
              <h4>Edlink Mappings</h4>
              <Row gutter={[16, 8]}>
                {Object.entries(edlinkMappings).map(([key, value]) => (
                  <Col span={12} key={key}>
                     <Checkbox
                       checked={value}
                       disabled={key !== 'map_all_schools_in_district' && edlinkMappings.map_all_schools_in_district}
                       onChange={(e) => {
                         if (key === 'map_all_schools_in_district' && e.target.checked) {
                           // If enabling map_all_schools_in_district, disable all others
                           setEdlinkMappings({
                             ...defaultEdlinkMappings,
                             map_all_schools_in_district: true
                           });
                         } else {
                           setEdlinkMappings(prev => ({
                             ...prev,
                             [key]: e.target.checked
                           }));
                         }
                       }}
                     >
                       {key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                     </Checkbox>
                  </Col>
                ))}
              </Row>
            </div>
            <SyncConfigTable syncConfig={syncConfig} setSyncConfig={setSyncConfig} />
          </>
        )}
      </Modal>
      <Modal title={`${integrationLabel} Logs`} width={1000} visible={showLogsModal} onCancel={() => {
        setShowLogsModal(!showLogsModal)
      }} onOk={() => setShowLogsModal(!showLogsModal)}>
        {selectedIntegrationLogs ? (
          <pre>
            {(() => {
              const processLogs = (data) => {
                if (Array.isArray(data)) {
                  return data.map(processLogs);
                }
                if (typeof data === "object" && data !== null) {
                  return Object.fromEntries(
                    Object.entries(data).map(([key, value]) => [
                      key,
                      key === "logs_string" && typeof value === "string"
                        ? value.replace(/^\n/, "").split("\n")
                        : processLogs(value),
                    ])
                  );
                }
                return data;
              };
              const processedLogs = processLogs(selectedIntegrationLogs);
              return JSON.stringify(processedLogs, null, 2);
            })()}
          </pre>
        ) : (
          <p>{mrIntl("OrgIntegration.no_logs_available")}</p>
        )}
      </Modal>
      <Modal title="Sync Parameters" visible={showSyncModal} onCancel={() => {
        setShowSyncModal(false);
        setActiveIntegrationId(null);
      }} onOk={() => handleSync()}
      okText="Start Sync"
      >
          <Col>
            <Checkbox onChange={(e) => setSyncParams({...syncParams, full_sync: e.target.checked})}>Full Sync</Checkbox>
          </Col>
          <Col>
            <Checkbox onChange={(e) => setSyncParams({...syncParams, force_start: e.target.checked})}>Force Sync</Checkbox>
          </Col>
      </Modal>
    </>
  );
};

export default OrgIntegration;